import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Attribute } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Attribute>>>;

const createAttributeForOrganization = (
    organizationUuid: string,
    name: string,
    type: string,
    category: string,
    subCategory: string,
    choices?: string[],
): ReturnType => {
    const params: any = {
        name,
        type,
        category,
        sub_category: subCategory,
    };

    if (choices && choices.length > 0) {
        params.choices = choices;
    }

    return Request.post(`/attributes/${organizationUuid}`, params);
};

export default createAttributeForOrganization;
